import { render, staticRenderFns } from "./transformOrder.vue?vue&type=template&id=a6b9bbc6&scoped=true"
import script from "./transformOrder.vue?vue&type=script&lang=js"
export * from "./transformOrder.vue?vue&type=script&lang=js"
import style0 from "./transformOrder.vue?vue&type=style&index=0&id=a6b9bbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b9bbc6",
  null
  
)

export default component.exports